import { render, staticRenderFns } from "./MangoTraining.vue?vue&type=template&id=1dc16b86&scoped=true"
import script from "./MangoTraining.vue?vue&type=script&lang=js"
export * from "./MangoTraining.vue?vue&type=script&lang=js"
import style0 from "./MangoTraining.vue?vue&type=style&index=0&id=1dc16b86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc16b86",
  null
  
)

export default component.exports